import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('sameAiWarningBanner');

    return {
        EXCEEDS_CAP_BADGE: t('exceedsCapBadge'),
        TITLE: t('title'),
        description: (name: string, total: string): string => t('description', { name, total })
    };
};

export default useTranslation;
